const userData = {
  email: "",
  name: "",
  lastname: "",
  postcode: "",
  optin: "",
  activeClient: "",
  phone: "",
  address: "",
  request: "",
  referral: "Event form",
  promoCode: "",
  age_range: "",
  utm_medium: "",
  utm_campaign: "",
  utm_term: "",
  utm_content: "",
  utm_source: "",
  leafQA: "",
};

const klaviyoFlags ={
  inArea: "No",
}

// START loqate address capture
const apiKey = 'GP98-NP91-HP23-KZ19';

        const searchInput = document.getElementById('addressSearch');
        const suggestionsWrapper = document.getElementById('suggestionsWrapper');
        const suggestionsDiv = document.getElementById('suggestions');
        const successMessage = document.getElementById('successMessage');
        
        let debounceTimer;
        
        async function findAddress(text, container = '') {
            try {
                const params = new URLSearchParams({
                    Key: apiKey,
                    Text: text,
                    Container: container,
                    Countries: 'GBR'
                });
                
                const response = await fetch(
                    `https://api.addressy.com/Capture/Interactive/Find/v1.10/json6.ws?${params}`
                );
                
                const data = await response.json();
                
                if (data.Items && data.Items[0] && data.Items[0].Error) {
                    console.error('API Error:', data.Items[0].Description);
                    return [];
                }
                
                return data.Items || [];
            } catch (error) {
                console.error('Find error:', error);
                return [];
            }
        }
        
        async function retrieveAddress(id) {
            try {
                const params = new URLSearchParams({
                    Key: apiKey,
                    Id: id,
                    Field1Format: '{Latitude}',
                    Field2Format: '{Longitude}'
                });
                
                const response = await fetch(
                    `https://api.addressy.com/Capture/Interactive/Retrieve/v1.00/json6.ws?${params}`
                );
                
                const data = await response.json();
                
                if (data.Items && data.Items[0] && data.Items[0].Error) {
                    console.error('API Error:', data.Items[0].Description);
                    return null;
                }
                
                return data.Items[0];
            } catch (error) {
                console.error('Retrieve error:', error);
                return null;
            }
        }
        
        function showSuggestions(results) {
            if (!results || results.length === 0) {
                hideSuggestions();
                return;
            }
            
            suggestionsDiv.innerHTML = '';
            
            results.forEach(result => {
                const div = document.createElement('div');
                div.className = 'suggestion';
                div.innerHTML = `
                    <div class="suggestion-text">${result.Text}</div>
                    <div class="suggestion-description">${result.Description}</div>
                `;
                
                div.addEventListener('click', async () => {
                    if (result.Type === 'Address') {
                        const address = await retrieveAddress(result.Id);
                        if (address) {
                            populateForm(address);
                            searchInput.value = result.Text + ', ' + result.Description;
                            hideSuggestions();
                        }
                    } else {
                        searchInput.value = result.Text;
                        const moreResults = await findAddress(result.Text, result.Id);
                        showSuggestions(moreResults);
                    }
                });
                
                suggestionsDiv.appendChild(div);
            });
            
            suggestionsWrapper.style.display = 'block';
            suggestionsDiv.style.display = 'block';
        }
        
        function hideSuggestions() {
            suggestionsWrapper.style.display = 'none';
            suggestionsDiv.style.display = 'none';
        }
        
        function populateForm(address) {
          console.log(address);
            document.getElementById('postalCode').value = address.PostalCode || '';
            setAddressData(address);
        }
        
        searchInput.addEventListener('input', function(e) {
            const searchTerm = e.target.value;
            
            clearTimeout(debounceTimer);
            
            if (searchTerm.length < 3) {
                hideSuggestions();
                return;
            }
            
            debounceTimer = setTimeout(async () => {
                const results = await findAddress(searchTerm);
                showSuggestions(results);
            }, 300);
        });
        
        document.addEventListener('click', function(e) {
            if (!e.target.closest('#addressSearch') && !e.target.closest('#suggestions')) {
                hideSuggestions();
            }
        });

//END loqate address capture

// define your polygons (as arrays of LatLng coordinates)
const polygons = [
  {
    name: "Aycliffe",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.5652302, lat: 54.8655303 },
        { lng: -1.5700778, lat: 54.8770226 },
        { lng: -1.5820334, lat: 54.8681482 },
        { lng: -1.5993361, lat: 54.8621784 },
        { lng: -1.6217597, lat: 54.8595622 },
        { lng: -1.6360273, lat: 54.8574867 },
        { lng: -1.6588443, lat: 54.8343778 },
        { lng: -1.7245205, lat: 54.8063093 },
        { lng: -1.7846156, lat: 54.797504 },
        { lng: -1.8402697, lat: 54.7577645 },
        { lng: -1.9413825, lat: 54.7798732 },
        { lng: -1.9950588, lat: 54.7863194 },
        { lng: -2.1317258, lat: 54.7845533 },
        { lng: -2.2547932, lat: 54.7583992 },
        { lng: -2.2361503, lat: 54.67761 },
        { lng: -2.1955593, lat: 54.642338 },
        { lng: -2.17496, lat: 54.6363774 },
        { lng: -2.1560678, lat: 54.6274191 },
        { lng: -2.1461242, lat: 54.6196627 },
        { lng: -2.1454341, lat: 54.5862735 },
        { lng: -2.0726497, lat: 54.5121978 },
        { lng: -2.0973689, lat: 54.4962501 },
        { lng: -2.1021337, lat: 54.4796225 },
        { lng: -2.0873651, lat: 54.4592489 },
        { lng: -2.0671308, lat: 54.4112771 },
        { lng: -2.1238048, lat: 54.3730431 },
        { lng: -2.1700312, lat: 54.3522269 },
        { lng: -2.1604183, lat: 54.3458236 },
        { lng: -2.1720911, lat: 54.3380181 },
        { lng: -2.1690013, lat: 54.3322132 },
        { lng: -2.2174098, lat: 54.3328136 },
        { lng: -2.2373226, lat: 54.3107876 },
        { lng: -2.2129416, lat: 54.2943667 },
        { lng: -2.1545817, lat: 54.2845412 },
        { lng: -2.0467725, lat: 54.2786225 },
        { lng: -1.9743283, lat: 54.2705808 },
        { lng: -1.8685939, lat: 54.27492 },
        { lng: -1.7728288, lat: 54.2616597 },
        { lng: -1.7271449, lat: 54.3086845 },
        { lng: -1.6005858, lat: 54.3331628 },
        { lng: -1.5357206, lat: 54.3860008 },
        { lng: -1.4851098, lat: 54.4068806 },
        { lng: -1.4444979, lat: 54.4132237 },
        { lng: -1.417836, lat: 54.4306767 },
        { lng: -1.3739477, lat: 54.4209327 },
        { lng: -1.338947, lat: 54.4249528 },
        { lng: -1.3907945, lat: 54.4513301 },
        { lng: -1.4286039, lat: 54.4650945 },
        { lng: -1.4104078, lat: 54.5019925 },
        { lng: -1.3293994, lat: 54.5464344 },
        { lng: -1.3216744, lat: 54.5498943 },
        { lng: -1.3137776, lat: 54.5601725 },
        { lng: -1.3166521, lat: 54.5663181 },
        { lng: -1.3157617, lat: 54.5684763 },
        { lng: -1.3129829, lat: 54.5713809 },
        { lng: -1.3163848, lat: 54.573912 },
        { lng: -1.3171418, lat: 54.5770179 },
        { lng: -1.3224447, lat: 54.5779845 },
        { lng: -1.3266299, lat: 54.5779096 },
        { lng: -1.3294091, lat: 54.5779223 },
        { lng: -1.3315452, lat: 54.5783841 },
        { lng: -1.3756321, lat: 54.6068294 },
        { lng: -1.4055313, lat: 54.6412152 },
        { lng: -1.4275578, lat: 54.6846851 },
        { lng: -1.4394008, lat: 54.6930446 },
        { lng: -1.4485005, lat: 54.6972362 },
        { lng: -1.4505018, lat: 54.7202836 },
        { lng: -1.4566278, lat: 54.7457103 },
        { lng: -1.4880286, lat: 54.7589669 },
        { lng: -1.5143012, lat: 54.7639344 },
        { lng: -1.5277482, lat: 54.7697863 },
        { lng: -1.5302199, lat: 54.7668417 },
        { lng: -1.5327617, lat: 54.7734314 },
        { lng: -1.5333011, lat: 54.7835001 },
        { lng: -1.5233449, lat: 54.8113567 },
        { lng: -1.5645436, lat: 54.8486335 },
        { lng: -1.5647154, lat: 54.8551549 },
        { lng: -1.5652302, lat: 54.8655303 }
      ]
    }),
  },
  {
    name: "Barrington",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -2.0808996, lat: 55.873747 },
        { lng: -2.1417203, lat: 55.9086547 },
        { lng: -2.2429687, lat: 55.8801656 },
        { lng: -2.2656737, lat: 55.86931 },
        { lng: -2.2667432, lat: 55.854601 },
        { lng: -2.1953011, lat: 55.8267491 },
        { lng: -2.1030959, lat: 55.784931 },
        { lng: -2.0915433, lat: 55.7621472 },
        { lng: -2.1434561, lat: 55.746565 },
        { lng: -2.1829675, lat: 55.722463 },
        { lng: -2.1230445, lat: 55.7055939 },
        { lng: -2.094391, lat: 55.6959373 },
        { lng: -2.0673076, lat: 55.6457467 },
        { lng: -2.0716123, lat: 55.5903923 },
        { lng: -2.0842702, lat: 55.5671616 },
        { lng: -2.0325771, lat: 55.4606085 },
        { lng: -2.1424135, lat: 55.4079041 },
        { lng: -2.436654, lat: 55.3372762 },
        { lng: -2.6081208, lat: 55.2508822 },
        { lng: -2.5823003, lat: 55.1680914 },
        { lng: -2.4901903, lat: 55.1589972 },
        { lng: -2.4763611, lat: 55.1655698 },
        { lng: -2.1878164, lat: 55.1732446 },
        { lng: -2.1392512, lat: 55.157459 },
        { lng: -2.0065098, lat: 55.1202675 },
        { lng: -1.8440842, lat: 55.072662 },
        { lng: -1.8151003, lat: 55.049435 },
        { lng: -1.8049803, lat: 55.0366175 },
        { lng: -1.7958857, lat: 55.026011 },
        { lng: -1.7327419, lat: 55.0135516 },
        { lng: -1.6804719, lat: 54.9955481 },
        { lng: -1.6933655, lat: 54.9852427 },
        { lng: -1.6749698, lat: 54.9801893 },
        { lng: -1.6497132, lat: 54.975132 },
        { lng: -1.6466175, lat: 54.9749117 },
        { lng: -1.6431781, lat: 54.981095 },
        { lng: -1.6075146, lat: 54.9814148 },
        { lng: -1.6056904, lat: 54.9796291 },
        { lng: -1.6048963, lat: 54.9766613 },
        { lng: -1.6079496, lat: 54.9704011 },
        { lng: -1.606269, lat: 54.9685826 },
        { lng: -1.5949404, lat: 54.9707015 },
        { lng: -1.5863582, lat: 54.9696665 },
        { lng: -1.5803501, lat: 54.9658235 },
        { lng: -1.5734401, lat: 54.9644445 },
        { lng: -1.5685901, lat: 54.9650361 },
        { lng: -1.5534409, lat: 54.9599113 },
        { lng: -1.5455886, lat: 54.961093 },
        { lng: -1.5366276, lat: 54.9635802 },
        { lng: -1.5359905, lat: 54.9714873 },
        { lng: -1.5325129, lat: 54.9805908 },
        { lng: -1.5292059, lat: 54.9829953 },
        { lng: -1.5225506, lat: 54.9857445 },
        { lng: -1.5170107, lat: 54.9868681 },
        { lng: -1.4688496, lat: 54.9867445 },
        { lng: -1.4538668, lat: 54.9872696 },
        { lng: -1.4521017, lat: 54.9877941 },
        { lng: -1.4408258, lat: 55.0046157 },
        { lng: -1.4267495, lat: 55.0108175 },
        { lng: -1.4068121, lat: 55.0169489 },
        { lng: -1.4327193, lat: 55.0428869 },
        { lng: -1.4453234, lat: 55.0587836 },
        { lng: -1.5012136, lat: 55.1492016 },
        { lng: -1.4976354, lat: 55.2201069 },
        { lng: -1.5545364, lat: 55.271603 },
        { lng: -1.544353, lat: 55.3240991 },
        { lng: -1.5928663, lat: 55.3666016 },
        { lng: -1.5658105, lat: 55.4171871 },
        { lng: -1.5857468, lat: 55.4675519 },
        { lng: -1.5951777, lat: 55.5077052 },
        { lng: -1.6093458, lat: 55.5559968 },
        { lng: -1.7055908, lat: 55.6310595 },
        { lng: -1.7707638, lat: 55.6423088 },
        { lng: -1.7745111, lat: 55.682876 },
        { lng: -1.8778242, lat: 55.6990431 },
        { lng: -2.0580985, lat: 55.8429575 },
        { lng: -2.0808996, lat: 55.873747 }   
      ]
    }),
  },
  {
    name: "Birstall",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.3627752, lat: 53.7786257 },
        { lng: -1.4218264, lat: 53.7891736 },
        { lng: -1.3494804, lat: 53.8108645 },
        { lng: -1.3448822, lat: 53.816842 },
        { lng: -1.3384626, lat: 53.837258 },
        { lng: -1.3505872, lat: 53.8540257 },
        { lng: -1.3965855, lat: 53.8483307 },
        { lng: -1.4441424, lat: 53.8453171 },
        { lng: -1.4702219, lat: 53.8557522 },
        { lng: -1.526196, lat: 53.8684012 },
        { lng: -1.613743, lat: 53.8884376 },
        { lng: -1.7452349, lat: 53.8981488 },
        { lng: -1.8042861, lat: 53.9046216 },
        { lng: -1.8667705, lat: 53.9232255 },
        { lng: -1.9223886, lat: 53.9264601 },
        { lng: -1.9574073, lat: 53.9228212 },
        { lng: -1.9659903, lat: 53.9069476 },
        { lng: -1.9596381, lat: 53.8966305 },
        { lng: -1.9690802, lat: 53.8880329 },
        { lng: -1.9889928, lat: 53.8617203 },
        { lng: -1.9718268, lat: 53.8244494 },
        { lng: -2.0281314, lat: 53.7599574 },
        { lng: -2.1098419, lat: 53.74859 },
        { lng: -2.1733563, lat: 53.7410778 },
        { lng: -2.1201415, lat: 53.7091865 },
        { lng: -2.1036618, lat: 53.6841025 },
        { lng: -2.0425521, lat: 53.707384 },
        { lng: -1.9938014, lat: 53.6881695 },
        { lng: -1.9934561, lat: 53.681338 },
        { lng: -1.9766333, lat: 53.6404468 },
        { lng: -1.9526008, lat: 53.5940145 },
        { lng: -1.8296919, lat: 53.5475312 },
        { lng: -1.733554, lat: 53.52655 },
        { lng: -1.6762303, lat: 53.5278665 },
        { lng: -1.6470451, lat: 53.5401871 },
        { lng: -1.537869, lat: 53.5300868 },
        { lng: -1.4974429, lat: 53.516565 },
        { lng: -1.4774835, lat: 53.5174182 },
        { lng: -1.453125, lat: 53.5114353 },
        { lng: -1.4150364, lat: 53.5136103 },
        { lng: -1.4067203, lat: 53.5115123 },
        { lng: -1.3689999, lat: 53.515984 },
        { lng: -1.3303136, lat: 53.5150222 },
        { lng: -1.3386239, lat: 53.5370524 },
        { lng: -1.3583449, lat: 53.5563143 },
        { lng: -1.3531789, lat: 53.5715988 },
        { lng: -1.3533338, lat: 53.5843347 },
        { lng: -1.2900841, lat: 53.6407602 },
        { lng: -1.2543385, lat: 53.65037 },
        { lng: -1.2570322, lat: 53.673407 },
        { lng: -1.2899911, lat: 53.7047157 },
        { lng: -1.2927331, lat: 53.7322378 },
        { lng: -1.2755687, lat: 53.7462979 },
        { lng: -1.2954843, lat: 53.7733507 },
        { lng: -1.3126412, lat: 53.7772066 },
        { lng: -1.3627752, lat: 53.7786257 }
      ]
    }),
  },
  {
    name: "Chesterfield",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.9081561, lat: 53.2198656 },
        { lng: -1.7823246, lat: 53.0908311 },
        { lng: -1.787389, lat: 53.0018441 },
        { lng: -1.7327816, lat: 52.975225 },
        { lng: -1.6312582, lat: 52.9454302 },
        { lng: -1.6566638, lat: 52.8766903 },
        { lng: -1.6181342, lat: 52.8456207 },
        { lng: -1.5817001, lat: 52.8313341 },
        { lng: -1.4900511, lat: 52.8018761 },
        { lng: -1.3703254, lat: 52.7962173 },
        { lng: -1.076433, lat: 52.8061808 },
        { lng: -0.7921551, lat: 52.7841755 },
        { lng: -0.6652116, lat: 52.8692311 },
        { lng: -0.6809139, lat: 52.8957495 },
        { lng: -0.752327, lat: 52.9470851 },
        { lng: -0.8209935, lat: 53.0148871 },
        { lng: -0.8331928, lat: 53.0691455 },
        { lng: -0.8021108, lat: 53.117627 },
        { lng: -0.82374, lat: 53.148525 },
        { lng: -0.9253665, lat: 53.2184778 },
        { lng: -1.0517128, lat: 53.3104768 },
        { lng: -1.0887928, lat: 53.3850803 },
        { lng: -1.0901661, lat: 53.4481044 },
        { lng: -1.1847234, lat: 53.491798 },
        { lng: -1.2134225, lat: 53.4892855 },
        { lng: -1.2945179, lat: 53.5126814 },
        { lng: -1.3330738, lat: 53.5123621 },
        { lng: -1.3522676, lat: 53.5167183 },
        { lng: -1.3781578, lat: 53.5153542 },
        { lng: -1.3907958, lat: 53.5095609 },
        { lng: -1.4112681, lat: 53.5132801 },
        { lng: -1.4247374, lat: 53.5109388 },
        { lng: -1.4542617, lat: 53.5099165 },
        { lng: -1.4784714, lat: 53.5166538 },
        { lng: -1.5049115, lat: 53.5155262 },
        { lng: -1.5378719, lat: 53.5298145 },
        { lng: -1.6079118, lat: 53.5371606 },
        { lng: -1.6552919, lat: 53.5324675 },
        { lng: -1.6697117, lat: 53.522467 },
        { lng: -1.6614716, lat: 53.4775381 },
        { lng: -1.6642183, lat: 53.4382886 },
        { lng: -1.7438715, lat: 53.4014591 },
        { lng: -1.8509912, lat: 53.3662367 },
        { lng: -1.9114178, lat: 53.3424656 },
        { lng: -1.9498711, lat: 53.3588609 },
        { lng: -1.9624026, lat: 53.3886638 },
        { lng: -2.0041177, lat: 53.3940893 },
        { lng: -2.0370775, lat: 53.3727918 },
        { lng: -2.0408483, lat: 53.3537379 },
        { lng: -1.9999976, lat: 53.3486146 },
        { lng: -2.0089243, lat: 53.3285247 },
        { lng: -1.9773377, lat: 53.3182711 },
        { lng: -1.9447222, lat: 53.3110966 },
        { lng: -1.9141644, lat: 53.3211424 },
        { lng: -1.9210311, lat: 53.3022706 },
        { lng: -1.9416311, lat: 53.2899584 },
        { lng: -1.9584546, lat: 53.258957 },
        { lng: -1.9372409, lat: 53.2232836 },
        { lng: -1.9081561, lat: 53.2198656 }
      ]
    }),
  },
  {
    name: "Cumbria",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -3.2934908, lat: 54.9641956 },
        { lng: -3.4012682, lat: 54.8869376 },
        { lng: -3.4576194, lat: 54.8044143 },
        { lng: -3.4554401, lat: 54.7663296 },
        { lng: -3.586265, lat: 54.6711447 },
        { lng: -3.6000888, lat: 54.607519 },
        { lng: -3.6069517, lat: 54.5717253 },
        { lng: -3.6467546, lat: 54.5255426 },
        { lng: -3.6645464, lat: 54.5147902 },
        { lng: -3.5270885, lat: 54.4558913 },
        { lng: -3.5001472, lat: 54.4577256 },
        { lng: -3.4440093, lat: 54.5025787 },
        { lng: -3.39626, lat: 54.5372371 },
        { lng: -3.3134393, lat: 54.5745533 },
        { lng: -3.2879422, lat: 54.5895994 },
        { lng: -3.2026882, lat: 54.5883063 },
        { lng: -3.0836285, lat: 54.4545523 },
        { lng: -3.0422265, lat: 54.4257437 },
        { lng: -3.038519, lat: 54.3992984 },
        { lng: -3.0562254, lat: 54.3923772 },
        { lng: -3.0812651, lat: 54.3737138 },
        { lng: -3.0853749, lat: 54.362502 },
        { lng: -3.0877731, lat: 54.3542595 },
        { lng: -3.1085548, lat: 54.3032165 },
        { lng: -3.0977389, lat: 54.2553784 },
        { lng: -3.0575849, lat: 54.2538485 },
        { lng: -3.048021, lat: 54.234923 },
        { lng: -3.1660169, lat: 54.1857118 },
        { lng: -3.2859018, lat: 54.159299 },
        { lng: -3.3056316, lat: 54.1333525 },
        { lng: -3.2882462, lat: 54.0924888 },
        { lng: -3.2236716, lat: 54.0378876 },
        { lng: -3.1907377, lat: 54.0469562 },
        { lng: -3.1449577, lat: 54.0707681 },
        { lng: -3.0959031, lat: 54.1229235 },
        { lng: -3.0637303, lat: 54.1710942 },
        { lng: -2.9802924, lat: 54.146921 },
        { lng: -2.8343515, lat: 54.2179479 },
        { lng: -2.7993305, lat: 54.2038645 },
        { lng: -2.7888849, lat: 54.1448742 },
        { lng: -2.8336648, lat: 54.1210721 },
        { lng: -2.8556811, lat: 54.0945004 },
        { lng: -2.9394133, lat: 54.0542125 },
        { lng: -2.8982127, lat: 53.9662451 },
        { lng: -3.0053346, lat: 53.9290654 },
        { lng: -2.972374, lat: 53.8756628 },
        { lng: -2.9188131, lat: 53.8432643 },
        { lng: -2.8182137, lat: 53.8264472 },
        { lng: -2.7289949, lat: 53.8450612 },
        { lng: -2.7207546, lat: 53.8774583 },
        { lng: -2.7344881, lat: 54.0116383 },
        { lng: -2.5559516, lat: 54.1115876 },
        { lng: -2.4859104, lat: 54.1091722 },
        { lng: -2.4419302, lat: 54.1192763 },
        { lng: -2.3876988, lat: 54.094854 },
        { lng: -2.2593783, lat: 54.086469 },
        { lng: -2.2761292, lat: 54.1287118 },
        { lng: -2.2800549, lat: 54.1484213 },
        { lng: -2.3049319, lat: 54.1628994 },
        { lng: -2.4488297, lat: 54.143778 },
        { lng: -2.5600716, lat: 54.2112966 },
        { lng: -2.5118629, lat: 54.3199434 },
        { lng: -2.5404357, lat: 54.4097309 },
        { lng: -2.3803638, lat: 54.4361275 },
        { lng: -2.3008959, lat: 54.5226751 },
        { lng: -2.5700262, lat: 54.6320882 },
        { lng: -2.5700739, lat: 54.7404891 },
        { lng: -2.3630008, lat: 54.7600814 },
        { lng: -2.4066446, lat: 54.8056456 },
        { lng: -2.3781477, lat: 54.9139411 },
        { lng: -2.2837295, lat: 54.9715271 },
        { lng: -2.3256074, lat: 55.0085675 },
        { lng: -2.4155707, lat: 55.0103311 },
        { lng: -2.5954807, lat: 55.0028491 },
        { lng: -2.9165036, lat: 55.0051729 },
        { lng: -2.8922976, lat: 55.0901185 },
        { lng: -2.8290145, lat: 55.1184799 },
        { lng: -2.8164769, lat: 55.1625361 },
        { lng: -2.8017783, lat: 55.1823636 },
        { lng: -2.8238226, lat: 55.1872961 },
        { lng: -2.8642913, lat: 55.1232891 },
        { lng: -2.8994084, lat: 55.1067833 },
        { lng: -2.9551166, lat: 55.1152053 },
        { lng: -3.0017034, lat: 55.1746026 },
        { lng: -3.0236256, lat: 55.1667035 },
        { lng: -3.0432912, lat: 55.1571025 },
        { lng: -3.0090551, lat: 55.1310334 },
        { lng: -2.992673, lat: 55.0963249 },
        { lng: -2.994501, lat: 55.0667083 },
        { lng: -3.095727, lat: 55.0350916 },
        { lng: -3.1979654, lat: 55.0575472 },
        { lng: -3.2989843, lat: 55.0956477 },
        { lng: -3.2921174, lat: 55.1341357 },
        { lng: -3.3937461, lat: 55.1357057 },
        { lng: -3.4534872, lat: 55.1400233 },
        { lng: -3.4508528, lat: 55.1057616 },
        { lng: -3.4852721, lat: 55.0769968 },
        { lng: -3.5399149, lat: 55.0853477 },
        { lng: -3.5746317, lat: 55.1088648 },
        { lng: -3.584987, lat: 55.1109687 },
        { lng: -3.6049943, lat: 55.0945198 },
        { lng: -3.62225, lat: 55.0900511 },
        { lng: -3.6457634, lat: 55.0891643 },
        { lng: -3.6560246, lat: 55.0720683 },
        { lng: -3.6309975, lat: 55.0596778 },
        { lng: -3.5983841, lat: 55.0547678 },
        { lng: -3.5776094, lat: 55.0547658 },
        { lng: -3.5750296, lat: 55.0586957 },
        { lng: -3.4637874, lat: 55.0240714 },
        { lng: -3.2934908, lat: 54.9641956 }
      ]
    }),
  },
  {
    name: "East-Anglia",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: 0.6675182, lat: 52.6628043 },
        { lng: 0.6632981, lat: 52.6385459 },
        { lng: 0.6717772, lat: 52.5863652 },
        { lng: 0.6276932, lat: 52.5186832 },
        { lng: 0.6890709, lat: 52.4242954 },
        { lng: 0.647263, lat: 52.3675899 },
        { lng: 0.6512104, lat: 52.2499362 },
        { lng: 0.6728588, lat: 52.2186164 },
        { lng: 0.7540351, lat: 52.2056697 },
        { lng: 0.8337163, lat: 52.2016966 },
        { lng: 0.9160827, lat: 52.1719934 },
        { lng: 1.0492914, lat: 52.1351309 },
        { lng: 0.9743431, lat: 52.0804599 },
        { lng: 0.928976, lat: 52.0394508 },
        { lng: 1.0688605, lat: 52.0249933 },
        { lng: 1.187993, lat: 52.0199231 },
        { lng: 1.2377703, lat: 52.0110562 },
        { lng: 1.2745099, lat: 52.0287957 },
        { lng: 1.3007961, lat: 52.0749934 },
        { lng: 1.3419004, lat: 52.1070465 },
        { lng: 1.3895226, lat: 52.1627281 },
        { lng: 1.3785356, lat: 52.219133 },
        { lng: 1.411429, lat: 52.2884562 },
        { lng: 1.5552341, lat: 52.3010506 },
        { lng: 1.5881376, lat: 52.3199454 },
        { lng: 1.7208274, lat: 52.386243 },
        { lng: 1.7702655, lat: 52.4810629 },
        { lng: 1.7507162, lat: 52.5230538 },
        { lng: 1.7362767, lat: 52.5633676 },
        { lng: 1.7359333, lat: 52.5742184 },
        { lng: 1.6679557, lat: 52.5954955 },
        { lng: 1.6077204, lat: 52.624084 },
        { lng: 1.5405838, lat: 52.6369765 },
        { lng: 1.49373, lat: 52.6442858 },
        { lng: 1.4468579, lat: 52.6540762 },
        { lng: 1.412525, lat: 52.6515583 },
        { lng: 1.3459207, lat: 52.6936106 },
        { lng: 1.3207513, lat: 52.6980321 },
        { lng: 1.2811831, lat: 52.6974603 },
        { lng: 1.2351998, lat: 52.7092139 },
        { lng: 1.2168068, lat: 52.6958028 },
        { lng: 1.1944598, lat: 52.6919533 },
        { lng: 1.1793067, lat: 52.6815705 },
        { lng: 1.1425128, lat: 52.6595589 },
        { lng: 1.0620945, lat: 52.6812764 },
        { lng: 1.0001686, lat: 52.6830293 },
        { lng: 0.999831, lat: 52.719806 },
        { lng: 0.9030366, lat: 52.7212767 },
        { lng: 0.8943664, lat: 52.7100382 },
        { lng: 0.9001167, lat: 52.6908953 },
        { lng: 0.8718054, lat: 52.6809026 },
        { lng: 0.8357763, lat: 52.6819291 },
        { lng: 0.7768014, lat: 52.6606566 },
        { lng: 0.7193133, lat: 52.6551394 },
        { lng: 0.6675182, lat: 52.6628043 }
      ]
    }),
  },
  {
    name: "Edinburgh",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -3.4768323, lat: 56.0846974 },
        { lng: -3.4777083, lat: 56.0656885 },
        { lng: -3.4347929, lat: 56.051695 },
        { lng: -3.410932, lat: 56.0436416 },
        { lng: -3.4087877, lat: 56.0175564 },
        { lng: -3.4210155, lat: 55.9951522 },
        { lng: -3.4653151, lat: 56.0010801 },
        { lng: -3.5099601, lat: 56.0008716 },
        { lng: -3.517266, lat: 56.0062857 },
        { lng: -3.5583891, lat: 56.012275 },
        { lng: -3.5837636, lat: 56.0202293 },
        { lng: -3.6239297, lat: 56.0225665 },
        { lng: -3.6689098, lat: 56.0163352 },
        { lng: -3.7118271, lat: 56.0250126 },
        { lng: -3.7516798, lat: 56.0127548 },
        { lng: -3.7513515, lat: 56.0035549 },
        { lng: -3.7647524, lat: 55.9914553 },
        { lng: -3.7643827, lat: 55.9808829 },
        { lng: -3.6882634, lat: 55.9789992 },
        { lng: -3.6224705, lat: 55.9663172 },
        { lng: -3.4846799, lat: 55.9576888 },
        { lng: -3.5680979, lat: 55.9111535 },
        { lng: -3.6379008, lat: 55.9109455 },
        { lng: -3.674741, lat: 55.9084054 },
        { lng: -3.7123447, lat: 55.8651343 },
        { lng: -3.7217421, lat: 55.8191615 },
        { lng: -3.5991872, lat: 55.8241874 },
        { lng: -3.323024, lat: 55.8893958 },
        { lng: -3.254399, lat: 55.8931429 },
        { lng: -3.2121875, lat: 55.8799211 },
        { lng: -3.261977, lat: 55.830867 },
        { lng: -3.2139791, lat: 55.7566292 },
        { lng: -3.222894, lat: 55.6458065 },
        { lng: -3.0693646, lat: 55.6070974 },
        { lng: -2.9887478, lat: 55.6155715 },
        { lng: -2.8911612, lat: 55.5958981 },
        { lng: -2.8527215, lat: 55.54359 },
        { lng: -2.8520446, lat: 55.4829967 },
        { lng: -2.8129666, lat: 55.4426302 },
        { lng: -2.8241277, lat: 55.4252823 },
        { lng: -2.8037068, lat: 55.4110514 },
        { lng: -2.7675555, lat: 55.4089033 },
        { lng: -2.6681981, lat: 55.4480234 },
        { lng: -2.5416211, lat: 55.4520115 },
        { lng: -2.5213798, lat: 55.4905358 },
        { lng: -2.6028455, lat: 55.5593897 },
        { lng: -2.4339337, lat: 55.5827479 },
        { lng: -2.2916618, lat: 55.5315149 },
        { lng: -2.1703763, lat: 55.5585946 },
        { lng: -2.0774488, lat: 55.5927204 },
        { lng: -2.0777362, lat: 55.6408802 },
        { lng: -2.094391, lat: 55.6959373 },
        { lng: -2.1852937, lat: 55.7223194 },
        { lng: -2.1462485, lat: 55.746307 },
        { lng: -2.0958769, lat: 55.762367 },
        { lng: -2.1064091, lat: 55.7845306 },
        { lng: -2.1953011, lat: 55.8267491 },
        { lng: -2.2708091, lat: 55.8541756 },
        { lng: -2.2878242, lat: 55.8961089 },
        { lng: -2.3890897, lat: 55.7994797 },
        { lng: -2.3926912, lat: 55.7849408 },
        { lng: -2.4251155, lat: 55.7642214 },
        { lng: -2.494023, lat: 55.7350733 },
        { lng: -2.6637595, lat: 55.7355985 },
        { lng: -2.7101768, lat: 55.7308104 },
        { lng: -2.7991817, lat: 55.7909368 },
        { lng: -2.8381375, lat: 55.8284672 },
        { lng: -2.8537598, lat: 55.8401498 },
        { lng: -2.8311887, lat: 55.868441 },
        { lng: -2.6767679, lat: 55.8952305 },
        { lng: -2.7088904, lat: 55.9580894 },
        { lng: -2.6036272, lat: 55.9742839 },
        { lng: -2.5476086, lat: 55.9815217 },
        { lng: -2.5393169, lat: 55.9681965 },
        { lng: -2.5193051, lat: 55.9651689 },
        { lng: -2.5059241, lat: 55.9831805 },
        { lng: -2.4702099, lat: 55.9811146 },
        { lng: -2.4597986, lat: 55.9846231 },
        { lng: -2.47021, lat: 56.0026213 },
        { lng: -2.4938542, lat: 56.0045676 },
        { lng: -2.5317739, lat: 56.0120624 },
        { lng: -2.5555486, lat: 56.0096638 },
        { lng: -2.6002759, lat: 56.0293305 },
        { lng: -2.6350049, lat: 56.0571026 },
        { lng: -2.701243, lat: 56.0628872 },
        { lng: -2.7584074, lat: 56.0645134 },
        { lng: -2.7935183, lat: 56.0681908 },
        { lng: -2.8202275, lat: 56.064099 },
        { lng: -2.8396693, lat: 56.043707 },
        { lng: -2.8690506, lat: 56.0374996 },
        { lng: -2.8764329, lat: 56.020262 },
        { lng: -2.8959085, lat: 56.0067496 },
        { lng: -2.8907046, lat: 55.9950963 },
        { lng: -2.9186229, lat: 55.9786374 },
        { lng: -2.9572557, lat: 55.9740419 },
        { lng: -2.9800001, lat: 55.9675309 },
        { lng: -2.980406, lat: 55.9650136 },
        { lng: -2.9852746, lat: 55.9615353 },
        { lng: -3.016124, lat: 55.9539046 },
        { lng: -3.041686, lat: 55.9556015 },
        { lng: -3.0594457, lat: 55.9482778 },
        { lng: -3.0748474, lat: 55.948267 },
        { lng: -3.1014089, lat: 55.95383 },
        { lng: -3.1788281, lat: 55.9926376 },
        { lng: -3.2011428, lat: 55.9854047 },
        { lng: -3.211612, lat: 55.9850837 },
        { lng: -3.2288561, lat: 55.9890781 },
        { lng: -3.2647739, lat: 55.9809896 },
        { lng: -3.2815286, lat: 55.9819355 },
        { lng: -3.2977686, lat: 55.9830714 },
        { lng: -3.3211909, lat: 55.9864283 },
        { lng: -3.3449223, lat: 56.0009691 },
        { lng: -3.3641996, lat: 56.0028346 },
        { lng: -3.3772537, lat: 55.9942385 },
        { lng: -3.4009464, lat: 55.9929361 },
        { lng: -3.4018109, lat: 56.0100623 },
        { lng: -3.4049062, lat: 56.0235405 },
        { lng: -3.3953077, lat: 56.0257383 },
        { lng: -3.3804596, lat: 56.0241056 },
        { lng: -3.3503163, lat: 56.0266029 },
        { lng: -3.3405626, lat: 56.0393103 },
        { lng: -3.325912, lat: 56.0477475 },
        { lng: -3.2708851, lat: 56.057062 },
        { lng: -3.2291427, lat: 56.0553838 },
        { lng: -3.1998811, lat: 56.065722 },
        { lng: -3.2316254, lat: 56.068863 },
        { lng: -3.2935761, lat: 56.0608702 },
        { lng: -3.3831052, lat: 56.0463658 },
        { lng: -3.3707598, lat: 56.076833 },
        { lng: -3.3443336, lat: 56.0888982 },
        { lng: -3.3037976, lat: 56.1291144 },
        { lng: -3.4768323, lat: 56.0846974 }
      ],
    }),
  },
  {
    name: "Hull",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -0.9291068, lat: 53.6958614 },
        { lng: -0.9016413, lat: 53.6942352 },
        { lng: -0.8776089, lat: 53.6901694 },
        { lng: -0.8522033, lat: 53.6869166 },
        { lng: -0.816498, lat: 53.7088687 },
        { lng: -0.7876592, lat: 53.6983006 },
        { lng: -0.742341, lat: 53.7039914 },
        { lng: -0.6956496, lat: 53.7007396 },
        { lng: -0.6448383, lat: 53.7251221 },
        { lng: -0.5995201, lat: 53.7129326 },
        { lng: -0.5116303, lat: 53.7048043 },
        { lng: -0.3578232, lat: 53.7251221 },
        { lng: -0.2713068, lat: 53.7356834 },
        { lng: -0.1998962, lat: 53.6909827 },
        { lng: -0.1449652, lat: 53.6437922 },
        { lng: -0.0570754, lat: 53.6250641 },
        { lng: 0.0321876, lat: 53.642164 },
        { lng: 0.0871188, lat: 53.6234352 },
        { lng: 0.1530361, lat: 53.6283218 },
        { lng: 0.1173309, lat: 53.6657668 },
        { lng: -0.0515823, lat: 53.80224 },
        { lng: -0.1463385, lat: 53.9059224 },
        { lng: -0.19303, lat: 53.9705935 },
        { lng: -0.2134574, lat: 54.0489737 },
        { lng: -0.2920776, lat: 54.0248801 },
        { lng: -0.3221342, lat: 54.0138893 },
        { lng: -0.367951, lat: 53.9889659 },
        { lng: -0.420994, lat: 53.9350368 },
        { lng: -0.4855427, lat: 53.9025291 },
        { lng: -0.5785778, lat: 53.925132 },
        { lng: -0.7049193, lat: 53.9367543 },
        { lng: -0.7258617, lat: 53.8775973 },
        { lng: -0.7931523, lat: 53.8557333 },
        { lng: -0.8837887, lat: 53.7989958 },
        { lng: -0.9661853, lat: 53.7308093 },
        { lng: -0.9291068, lat: 53.6958614 }
      ]
    }),
  },
  {
    name: "Lancashire",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -2.2734994, lat: 53.9670924 },
        { lng: -2.2842565, lat: 53.9384481 },
        { lng: -2.3652807, lat: 53.9182334 },
        { lng: -2.4449315, lat: 53.8907256 },
        { lng: -2.4723973, lat: 53.8538854 },
        { lng: -2.5410619, lat: 53.8405178 },
        { lng: -2.6018375, lat: 53.8445939 },
        { lng: -2.6962438, lat: 53.8324141 },
        { lng: -2.7436359, lat: 53.8243178 },
        { lng: -2.8011289, lat: 53.818533 },
        { lng: -2.8982893, lat: 53.8318063 },
        { lng: -2.9530492, lat: 53.8583404 },
        { lng: -2.971584, lat: 53.8680573 },
        { lng: -2.9818883, lat: 53.88506 },
        { lng: -2.9993903, lat: 53.894159 },
        { lng: -3.0079808, lat: 53.932789 },
        { lng: -3.0526163, lat: 53.9230885 },
        { lng: -3.0560461, lat: 53.9060999 },
        { lng: -3.0515856, lat: 53.8704828 },
        { lng: -3.0611959, lat: 53.8376817 },
        { lng: -3.0620606, lat: 53.7786758 },
        { lng: -3.0436864, lat: 53.751494 },
        { lng: -3.0220571, lat: 53.7358599 },
        { lng: -2.9587209, lat: 53.729991 },
        { lng: -2.8710909, lat: 53.7359777 },
        { lng: -2.8514257, lat: 53.7443884 },
        { lng: -2.7785554, lat: 53.7644842 },
        { lng: -2.7729798, lat: 53.7631247 },
        { lng: -2.7624067, lat: 53.7612317 },
        { lng: -2.7366497, lat: 53.7630252 },
        { lng: -2.7311488, lat: 53.7625346 },
        { lng: -2.7233721, lat: 53.7640602 },
        { lng: -2.7192871, lat: 53.7587878 },
        { lng: -2.7087152, lat: 53.7600136 },
        { lng: -2.7044484, lat: 53.7593351 },
        { lng: -2.698579, lat: 53.7632035 },
        { lng: -2.6933664, lat: 53.7618054 },
        { lng: -2.672297, lat: 53.7646871 },
        { lng: -2.6491644, lat: 53.7400434 },
        { lng: -2.6313909, lat: 53.7176051 },
        { lng: -2.6336087, lat: 53.6993923 },
        { lng: -2.6597191, lat: 53.6890969 },
        { lng: -2.6642661, lat: 53.6853118 },
        { lng: -2.66229, lat: 53.6733931 },
        { lng: -2.6218841, lat: 53.6697632 },
        { lng: -2.5993543, lat: 53.6406978 },
        { lng: -2.5864432, lat: 53.6250385 },
        { lng: -2.5802358, lat: 53.6018443 },
        { lng: -2.5335439, lat: 53.5671968 },
        { lng: -2.4631448, lat: 53.5469074 },
        { lng: -2.4446233, lat: 53.5431307 },
        { lng: -2.4015226, lat: 53.5247655 },
        { lng: -2.3838551, lat: 53.5049639 },
        { lng: -2.3836835, lat: 53.4880126 },
        { lng: -2.4044545, lat: 53.4628794 },
        { lng: -2.3737015, lat: 53.4355846 },
        { lng: -2.3169072, lat: 53.4131824 },
        { lng: -2.3091824, lat: 53.3985486 },
        { lng: -2.3230784, lat: 53.3787896 },
        { lng: -2.3166422, lat: 53.370341 },
        { lng: -2.2956212, lat: 53.3615833 },
        { lng: -2.2812026, lat: 53.3577955 },
        { lng: -2.2461827, lat: 53.3490836 },
        { lng: -2.2420629, lat: 53.3371953 },
        { lng: -2.2616323, lat: 53.326124 },
        { lng: -2.255791, lat: 53.30756 },
        { lng: -2.236913, lat: 53.2928924 },
        { lng: -2.2273065, lat: 53.2987388 },
        { lng: -2.2025808, lat: 53.3253038 },
        { lng: -2.187647, lat: 53.3405792 },
        { lng: -2.1703083, lat: 53.3449846 },
        { lng: -2.182243, lat: 53.3610243 },
        { lng: -2.177038, lat: 53.3688686 },
        { lng: -2.1683979, lat: 53.3724105 },
        { lng: -2.1601873, lat: 53.3730838 },
        { lng: -2.1478582, lat: 53.3669966 },
        { lng: -2.1333378, lat: 53.3570127 },
        { lng: -2.1246606, lat: 53.3419049 },
        { lng: -2.1076559, lat: 53.3393543 },
        { lng: -2.0903141, lat: 53.3533873 },
        { lng: -2.0508321, lat: 53.3566659 },
        { lng: -2.0528911, lat: 53.3940397 },
        { lng: -2.0669682, lat: 53.4090895 },
        { lng: -2.0082797, lat: 53.4276175 },
        { lng: -1.9327972, lat: 53.4206712 },
        { lng: -1.9210578, lat: 53.436977 },
        { lng: -1.9251085, lat: 53.4508284 },
        { lng: -1.9382221, lat: 53.4646167 },
        { lng: -1.9652441, lat: 53.4743251 },
        { lng: -2.0087575, lat: 53.4771812 },
        { lng: -2.0096333, lat: 53.5094559 },
        { lng: -1.9825109, lat: 53.5312965 },
        { lng: -1.9799473, lat: 53.5635192 },
        { lng: -1.9756444, lat: 53.5843204 },
        { lng: -2.0130615, lat: 53.5895162 },
        { lng: -2.0374425, lat: 53.6079557 },
        { lng: -2.062148, lat: 53.6182372 },
        { lng: -2.0552057, lat: 53.6406786 },
        { lng: -2.0714315, lat: 53.6640366 },
        { lng: -2.1653025, lat: 53.7011444 },
        { lng: -2.181638, lat: 53.7143542 },
        { lng: -2.1950276, lat: 53.7438054 },
        { lng: -2.1830129, lat: 53.7495904 },
        { lng: -2.1878197, lat: 53.7604505 },
        { lng: -2.184728, lat: 53.7669455 },
        { lng: -2.1862954, lat: 53.7861492 },
        { lng: -2.1366852, lat: 53.8391571 },
        { lng: -1.9886093, lat: 53.8850944 },
        { lng: -1.9607324, lat: 53.8964477 },
        { lng: -1.9688027, lat: 53.9083781 },
        { lng: -1.9696587, lat: 53.9266809 },
        { lng: -1.9438279, lat: 53.9591764 },
        { lng: -1.9557542, lat: 53.9768863 },
        { lng: -1.9771319, lat: 53.9877955 },
        { lng: -2.0010767, lat: 53.9801248 },
        { lng: -2.0300836, lat: 53.9837507 },
        { lng: -2.0519676, lat: 53.9750732 },
        { lng: -2.0947999, lat: 53.9908158 },
        { lng: -2.157628, lat: 53.9991916 },
        { lng: -2.2132437, lat: 54.0096398 },
        { lng: -2.2443169, lat: 54.0186611 },
        { lng: -2.2649927, lat: 54.0263756 },
        { lng: -2.2773947, lat: 54.0346166 },
        { lng: -2.280874, lat: 54.046083 },
        { lng: -2.2724694, lat: 54.0546507 },
        { lng: -2.2672339, lat: 54.0659324 },
        { lng: -2.2716111, lat: 54.08487 },
        { lng: -2.2855171, lat: 54.087088 },
        { lng: -2.2982186, lat: 54.0800363 },
        { lng: -2.2937554, lat: 54.0453791 },
        { lng: -2.2388821, lat: 53.9961467 },
        { lng: -2.234866, lat: 53.9812092 },
        { lng: -2.2734994, lat: 53.9670924 }
      ]
    }),
  },
  {
    name: "Leicester",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.610142, lat: 52.8192033 },
        { lng: -1.6142617, lat: 52.8389088 },
        { lng: -1.6451595, lat: 52.8374571 },
        { lng: -1.6774306, lat: 52.8144312 },
        { lng: -1.6904756, lat: 52.7895249 },
        { lng: -1.6588917, lat: 52.7776893 },
        { lng: -1.6324506, lat: 52.7782125 },
        { lng: -1.611162, lat: 52.7741593 },
        { lng: -1.5950364, lat: 52.7513067 },
        { lng: -1.6066143, lat: 52.7469915 },
        { lng: -1.5680735, lat: 52.7304121 },
        { lng: -1.552123, lat: 52.6982861 },
        { lng: -1.5517868, lat: 52.6835093 },
        { lng: -1.5778709, lat: 52.661446 },
        { lng: -1.6180381, lat: 52.6316596 },
        { lng: -1.6393239, lat: 52.6058113 },
        { lng: -1.6225012, lat: 52.5997677 },
        { lng: -1.6010253, lat: 52.5758585 },
        { lng: -1.5634313, lat: 52.5730121 },
        { lng: -1.562425, lat: 52.5383197 },
        { lng: -1.543338, lat: 52.5212872 },
        { lng: -1.5318365, lat: 52.4816823 },
        { lng: -1.5531208, lat: 52.4693493 },
        { lng: -1.5435073, lat: 52.4624038 },
        { lng: -1.5527766, lat: 52.4559813 },
        { lng: -1.5792006, lat: 52.4319415 },
        { lng: -1.6044044, lat: 52.4195458 },
        { lng: -1.612088, lat: 52.4067284 },
        { lng: -1.6061286, lat: 52.3952142 },
        { lng: -1.5892887, lat: 52.3736916 },
        { lng: -1.5889293, lat: 52.3635898 },
        { lng: -1.5950896, lat: 52.3572582 },
        { lng: -1.594693, lat: 52.3361404 },
        { lng: -1.5678889, lat: 52.3246493 },
        { lng: -1.5771418, lat: 52.3042363 },
        { lng: -1.6083409, lat: 52.2934254 },
        { lng: -1.608254, lat: 52.2862923 },
        { lng: -1.6129694, lat: 52.274724 },
        { lng: -1.6125338, lat: 52.2591642 },
        { lng: -1.5472953, lat: 52.2771344 },
        { lng: -1.4655913, lat: 52.2861089 },
        { lng: -1.456756, lat: 52.281583 },
        { lng: -1.4044985, lat: 52.2509964 },
        { lng: -1.4021212, lat: 52.2456439 },
        { lng: -1.39544, lat: 52.2427572 },
        { lng: -1.3866991, lat: 52.2440744 },
        { lng: -1.3575579, lat: 52.2512225 },
        { lng: -1.3298282, lat: 52.2501628 },
        { lng: -1.30296, lat: 52.2585121 },
        { lng: -1.2789813, lat: 52.2580121 },
        { lng: -1.2094014, lat: 52.2456173 },
        { lng: -1.1835361, lat: 52.2451873 },
        { lng: -1.0896036, lat: 52.233925 },
        { lng: -1.0730355, lat: 52.2399718 },
        { lng: -1.061522, lat: 52.2415371 },
        { lng: -1.0165349, lat: 52.2281263 },
        { lng: -0.9798189, lat: 52.2318655 },
        { lng: -0.9202611, lat: 52.2351249 },
        { lng: -0.9119352, lat: 52.2365698 },
        { lng: -0.9162265, lat: 52.2404328 },
        { lng: -0.9239524, lat: 52.2472126 },
        { lng: -0.9161418, lat: 52.2556195 },
        { lng: -0.920952, lat: 52.261485 },
        { lng: -0.9575246, lat: 52.2656649 },
        { lng: -0.9702379, lat: 52.2530078 },
        { lng: -0.9641925, lat: 52.2383593 },
        { lng: -0.9856101, lat: 52.2369546 },
        { lng: -1.0232878, lat: 52.2343454 },
        { lng: -1.0478354, lat: 52.2455225 },
        { lng: -1.0653614, lat: 52.2525309 },
        { lng: -1.078086, lat: 52.2607984 },
        { lng: -1.0843662, lat: 52.2728481 },
        { lng: -1.1169783, lat: 52.3072871 },
        { lng: -1.1425359, lat: 52.3309923 },
        { lng: -1.1576592, lat: 52.3693765 },
        { lng: -1.1711909, lat: 52.4004905 },
        { lng: -1.187011, lat: 52.4256456 },
        { lng: -1.1891073, lat: 52.4453566 },
        { lng: -1.1668595, lat: 52.4420791 },
        { lng: -1.0880298, lat: 52.4382523 },
        { lng: -0.9875322, lat: 52.4521171 },
        { lng: -0.8922816, lat: 52.463393 },
        { lng: -0.881639, lat: 52.496011 },
        { lng: -0.9447099, lat: 52.5157903 },
        { lng: -1.0044353, lat: 52.5559978 },
        { lng: -1.0167024, lat: 52.5775518 },
        { lng: -1.0259339, lat: 52.5925 },
        { lng: -1.0211026, lat: 52.6059859 },
        { lng: -1.0295472, lat: 52.6317818 },
        { lng: -1.0457056, lat: 52.6741815 },
        { lng: -1.0134699, lat: 52.7217895 },
        { lng: -0.9612869, lat: 52.7332246 },
        { lng: -0.8555476, lat: 52.7492287 },
        { lng: -0.873743, lat: 52.7805962 },
        { lng: -0.9526946, lat: 52.79321 },
        { lng: -1.0419413, lat: 52.8008953 },
        { lng: -1.1327157, lat: 52.7994932 },
        { lng: -1.2577348, lat: 52.7961677 },
        { lng: -1.3373826, lat: 52.7907705 },
        { lng: -1.4443233, lat: 52.7920166 },
        { lng: -1.610142, lat: 52.8192033 }
      ]
    }),
  },
  {
    name: "Peterborough",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -0.8128755, lat: 52.5425121 },
        { lng: -0.8485876, lat: 52.4367015 },
        { lng: -0.806009, lat: 52.3759928 },
        { lng: -0.6398408, lat: 52.2849369 },
        { lng: -0.5553835, lat: 52.2399692 },
        { lng: -0.5261835, lat: 52.1879688 },
        { lng: -0.5435316, lat: 52.1495461 },
        { lng: -0.5299776, lat: 52.1170217 },
        { lng: -0.4558199, lat: 52.1077448 },
        { lng: -0.3323387, lat: 52.1497093 },
        { lng: -0.2415864, lat: 52.2033732 },
        { lng: -0.168913, lat: 52.2630996 },
        { lng: 0.0715239, lat: 52.2719136 },
        { lng: 0.1043363, lat: 52.3290401 },
        { lng: 0.3022368, lat: 52.3843757 },
        { lng: 0.3095159, lat: 52.415501 },
        { lng: 0.2720519, lat: 52.5290676 },
        { lng: 0.284384, lat: 52.6155311 },
        { lng: 0.2212126, lat: 52.8056419 },
        { lng: 0.1401885, lat: 52.8703479 },
        { lng: -0.0802247, lat: 52.890031 },
        { lng: -0.1901065, lat: 52.8879797 },
        { lng: -0.2659623, lat: 52.8769791 },
        { lng: -0.3221436, lat: 52.8677704 },
        { lng: -0.3709918, lat: 52.8634691 },
        { lng: -0.4346067, lat: 52.8554398 },
        { lng: -0.6467073, lat: 52.8222424 },
        { lng: -0.7593172, lat: 52.7025774 },
        { lng: -0.7765041, lat: 52.6496731 },
        { lng: -0.7936495, lat: 52.5967664 },
        { lng: -0.8128755, lat: 52.5425121 }
      ]
    }),
  },
  {
    name: "Rasen",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.0634032, lat: 53.3516235 },
        { lng: -1.0490992, lat: 53.3134113 },
        { lng: -0.8183886, lat: 53.1461235 },
        { lng: -0.7957295, lat: 53.1164615 },
        { lng: -0.8273149, lat: 53.0686297 },
        { lng: -0.8094623, lat: 53.0149619 },
        { lng: -0.7359921, lat: 52.9421974 },
        { lng: -0.671448, lat: 52.8929292 },
        { lng: -0.5457931, lat: 52.8688959 },
        { lng: -0.4208252, lat: 52.8618489 },
        { lng: -0.1839341, lat: 52.8910649 },
        { lng: -0.080237, lat: 52.8972583 },
        { lng: 0.0283526, lat: 52.926136 },
        { lng: 0.1821598, lat: 53.0014069 },
        { lng: 0.3359668, lat: 53.066233 },
        { lng: 0.3785384, lat: 53.2062872 },
        { lng: 0.3236073, lat: 53.3114385 },
        { lng: 0.2570583, lat: 53.3802586 },
        { lng: 0.2123719, lat: 53.4355611 },
        { lng: 0.1582122, lat: 53.5011532 },
        { lng: 0.0413987, lat: 53.5340276 },
        { lng: -0.0526707, lat: 53.5731872 },
        { lng: -0.2057912, lat: 53.6513976 },
        { lng: -0.2785062, lat: 53.7263355 },
        { lng: -0.5346912, lat: 53.6912617 },
        { lng: -0.6267008, lat: 53.7132115 },
        { lng: -0.6969094, lat: 53.6995959 },
        { lng: -0.7567371, lat: 53.7008304 },
        { lng: -0.7706825, lat: 53.6977247 },
        { lng: -0.7935537, lat: 53.6994942 },
        { lng: -0.8178625, lat: 53.7042677 },
        { lng: -0.8440018, lat: 53.6874915 },
        { lng: -0.8804141, lat: 53.6711313 },
        { lng: -0.8914178, lat: 53.636432 },
        { lng: -0.9070349, lat: 53.6079726 },
        { lng: -0.9174924, lat: 53.586844 },
        { lng: -0.9422555, lat: 53.5294948 },
        { lng: -0.9707069, lat: 53.4633675 },
        { lng: -1.092242, lat: 53.4596883 },
        { lng: -1.0853756, lat: 53.4015966 },
        { lng: -1.0634032, lat: 53.3516235 }
      ]
    }),
  },
  {
    name: "Scarborough",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -0.6841524, lat: 54.5088371 },
        { lng: -0.7346075, lat: 54.5049759 },
        { lng: -0.7804993, lat: 54.4895847 },
        { lng: -0.8332057, lat: 54.462008 },
        { lng: -1.0691889, lat: 54.2667402 },
        { lng: -1.0577995, lat: 54.2096297 },
        { lng: -1.0519163, lat: 54.2043043 },
        { lng: -1.0161542, lat: 54.1649349 },
        { lng: -0.9502655, lat: 54.1357017 },
        { lng: -0.9080891, lat: 54.1279109 },
        { lng: -0.8721216, lat: 54.1048164 },
        { lng: -0.7925397, lat: 54.0547482 },
        { lng: -0.6959971, lat: 53.9739722 },
        { lng: -0.704701, lat: 53.9381302 },
        { lng: -0.5818843, lat: 53.925666 },
        { lng: -0.5425317, lat: 53.9188099 },
        { lng: -0.4855427, lat: 53.9025291 },
        { lng: -0.4272716, lat: 53.9351314 },
        { lng: -0.4080969, lat: 53.9523594 },
        { lng: -0.3757665, lat: 53.9866914 },
        { lng: -0.316282, lat: 54.0187757 },
        { lng: -0.2453832, lat: 54.0441921 },
        { lng: -0.210882, lat: 54.0574859 },
        { lng: -0.1319177, lat: 54.1034073 },
        { lng: -0.1078999, lat: 54.0985848 },
        { lng: -0.0632532, lat: 54.1162884 },
        { lng: -0.2500208, lat: 54.1806339 },
        { lng: -0.2603205, lat: 54.1991109 },
        { lng: -0.2500208, lat: 54.2159813 },
        { lng: -0.3571375, lat: 54.2561121 },
        { lng: -0.3989858, lat: 54.3065942 },
        { lng: -0.4175623, lat: 54.3570687 },
        { lng: -0.5094607, lat: 54.4234099 },
        { lng: -0.5184271, lat: 54.4449855 },
        { lng: -0.5631311, lat: 54.4833154 },
        { lng: -0.6841524, lat: 54.5088371 }
      ]
    }),
  },
  {
    name: "South-Tyne",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.3134955, lat: 54.8200345 },
        { lng: -1.3525742, lat: 54.883626 },
        { lng: -1.3553208, lat: 54.8958687 },
        { lng: -1.3525742, lat: 54.9108708 },
        { lng: -1.3609017, lat: 54.9337274 },
        { lng: -1.3571252, lat: 54.9414193 },
        { lng: -1.3475121, lat: 54.954433 },
        { lng: -1.3530053, lat: 54.96626 },
        { lng: -1.3715447, lat: 54.9772954 },
        { lng: -1.372918, lat: 54.9843879 },
        { lng: -1.4141167, lat: 55.0098911 },
        { lng: -1.4379777, lat: 55.0054613 },
        { lng: -1.4412392, lat: 55.0005386 },
        { lng: -1.4487923, lat: 54.9876383 },
        { lng: -1.4596423, lat: 54.986462 },
        { lng: -1.4864387, lat: 54.9865128 },
        { lng: -1.5130641, lat: 54.9863115 },
        { lng: -1.5238794, lat: 54.9848343 },
        { lng: -1.5312601, lat: 54.9810417 },
        { lng: -1.535895, lat: 54.9625181 },
        { lng: -1.5532328, lat: 54.9590686 },
        { lng: -1.5652491, lat: 54.9639963 },
        { lng: -1.5764071, lat: 54.9639963 },
        { lng: -1.5844751, lat: 54.9668542 },
        { lng: -1.5879082, lat: 54.9689975 },
        { lng: -1.5907407, lat: 54.9699951 },
        { lng: -1.5939165, lat: 54.9700074 },
        { lng: -1.6057612, lat: 54.9680859 },
        { lng: -1.6079496, lat: 54.9704011 },
        { lng: -1.6056749, lat: 54.9752781 },
        { lng: -1.6058895, lat: 54.9788495 },
        { lng: -1.6075848, lat: 54.9807583 },
        { lng: -1.6102243, lat: 54.9810417 },
        { lng: -1.6266324, lat: 54.9809985 },
        { lng: -1.643212, lat: 54.980756 },
        { lng: -1.6464019, lat: 54.976153 },
        { lng: -1.6497132, lat: 54.975132 },
        { lng: -1.6757448, lat: 54.9801383 },
        { lng: -1.6933655, lat: 54.9852427 },
        { lng: -1.6812641, lat: 54.9950418 },
        { lng: -1.7351651, lat: 55.0137474 },
        { lng: -1.7967944, lat: 55.0259027 },
        { lng: -1.815104, lat: 55.0489896 },
        { lng: -1.8440842, lat: 55.072662 },
        { lng: -2.1948695, lat: 55.1707948 },
        { lng: -2.2605347, lat: 55.1706278 },
        { lng: -2.3576951, lat: 55.1672942 },
        { lng: -2.4085069, lat: 55.1221658 },
        { lng: -2.2793945, lat: 54.9698545 },
        { lng: -2.3748382, lat: 54.9102953 },
        { lng: -2.4001598, lat: 54.8058203 },
        { lng: -2.3592646, lat: 54.7628336 },
        { lng: -2.232751, lat: 54.764101 },
        { lng: -2.1275087, lat: 54.7870954 },
        { lng: -1.967649, lat: 54.790922 },
        { lng: -1.9274189, lat: 54.7852268 },
        { lng: -1.8417474, lat: 54.7638496 },
        { lng: -1.7854023, lat: 54.8006043 },
        { lng: -1.7259743, lat: 54.8082347 },
        { lng: -1.6617573, lat: 54.8346163 },
        { lng: -1.6373111, lat: 54.8580158 },
        { lng: -1.6000179, lat: 54.8624711 },
        { lng: -1.5824585, lat: 54.868748 },
        { lng: -1.575486, lat: 54.8754222 },
        { lng: -1.5698243, lat: 54.8776117 },
        { lng: -1.5625762, lat: 54.8668868 },
        { lng: -1.5620612, lat: 54.8447524 },
        { lng: -1.5112494, lat: 54.8067299 },
        { lng: -1.4552878, lat: 54.832692 },
        { lng: -1.3895415, lat: 54.8234959 },
        { lng: -1.3134955, lat: 54.8200345 }     
      ]
    }),
  },
  {
    name: "St-Helens-A",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -2.2629032, lat: 53.3289178 },
        { lng: -2.260878, lat: 53.3259183 },
        { lng: -2.2629445, lat: 53.3304143 },
        { lng: -2.2629032, lat: 53.3289178 }
      ]
    }),
  },
  {
    name: "St-Helens-B",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -2.25844, lat: 53.3206128 },
        { lng: -2.2486561, lat: 53.3211022 },
        { lng: -2.2350949, lat: 53.3212824 },
        { lng: -2.2079713, lat: 53.3220484 },
        { lng: -2.1908051, lat: 53.3239965 },
        { lng: -2.1784454, lat: 53.3350685 },
        { lng: -2.165079, lat: 53.3384895 },
        { lng: -2.1566728, lat: 53.3379869 },
        { lng: -2.147923, lat: 53.3399437 },
        { lng: -2.1578888, lat: 53.3485715 },
        { lng: -2.1525894, lat: 53.3490964 },
        { lng: -2.1440271, lat: 53.3529263 },
        { lng: -2.1324399, lat: 53.3566917 },
        { lng: -2.1594767, lat: 53.3726203 },
        { lng: -2.1736831, lat: 53.3686 },
        { lng: -2.1785312, lat: 53.363197 },
        { lng: -2.173509, lat: 53.3537969 },
        { lng: -2.167974, lat: 53.3452153 },
        { lng: -2.1730382, lat: 53.340091 },
        { lng: -2.1956118, lat: 53.3239965 },
        { lng: -2.2279705, lat: 53.3222575 },
        { lng: -2.2586116, lat: 53.322561 },
        { lng: -2.260878, lat: 53.3259183 },
        { lng: -2.25844, lat: 53.3206128 }
      ]
    }),
  },
  {
    name: "St-Helens-C",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -2.2629445, lat: 53.3304143 },
        { lng: -2.2634181, lat: 53.3475723 },
        { lng: -2.2896825, lat: 53.357204 },
        { lng: -2.318956, lat: 53.3720041 },
        { lng: -2.3242725, lat: 53.3764605 },
        { lng: -2.3133843, lat: 53.3938903 },
        { lng: -2.3102696, lat: 53.3972492 },
        { lng: -2.3088713, lat: 53.3997379 },
        { lng: -2.315775, lat: 53.4121853 },
        { lng: -2.3473701, lat: 53.4249848 },
        { lng: -2.3683038, lat: 53.4327467 },
        { lng: -2.3753419, lat: 53.436326 },
        { lng: -2.3800546, lat: 53.4392451 },
        { lng: -2.3857692, lat: 53.4470912 },
        { lng: -2.3959414, lat: 53.4547292 },
        { lng: -2.3997178, lat: 53.4575911 },
        { lng: -2.4043529, lat: 53.4685262 },
        { lng: -2.3871867, lat: 53.4928391 },
        { lng: -2.401263, lat: 53.5204041 },
        { lng: -2.431559, lat: 53.5346162 },
        { lng: -2.4632467, lat: 53.5455555 },
        { lng: -2.5369745, lat: 53.5655655 },
        { lng: -2.585628, lat: 53.6040102 },
        { lng: -2.5938679, lat: 53.6219334 },
        { lng: -2.6047059, lat: 53.6413032 },
        { lng: -2.6246597, lat: 53.6696282 },
        { lng: -2.6625329, lat: 53.6726575 },
        { lng: -2.6645489, lat: 53.6873974 },
        { lng: -2.6377268, lat: 53.6992386 },
        { lng: -2.635509, lat: 53.7174514 },
        { lng: -2.6666526, lat: 53.7504311 },
        { lng: -2.6907587, lat: 53.7509153 },
        { lng: -2.7167557, lat: 53.7553516 },
        { lng: -2.7256187, lat: 53.7590581 },
        { lng: -2.748278, lat: 53.758297 },
        { lng: -2.7636031, lat: 53.7559123 },
        { lng: -2.7911936, lat: 53.749822 },
        { lng: -2.9502387, lat: 53.7163118 },
        { lng: -3.0206515, lat: 53.6909033 },
        { lng: -3.0386634, lat: 53.6706687 },
        { lng: -3.0346965, lat: 53.6540946 },
        { lng: -3.117781, lat: 53.5526426 },
        { lng: -3.0758954, lat: 53.5159133 },
        { lng: -3.0525494, lat: 53.4783348 },
        { lng: -3.0182169, lat: 53.4427679 },
        { lng: -3.006029, lat: 53.4156643 },
        { lng: -3.008084, lat: 53.4143315 },
        { lng: -3.0139167, lat: 53.4125385 },
        { lng: -3.0168298, lat: 53.4119742 },
        { lng: -3.0357264, lat: 53.4390869 },
        { lng: -3.0594158, lat: 53.4460397 },
        { lng: -3.1473068, lat: 53.4157663 },
        { lng: -3.2008655, lat: 53.3928424 },
        { lng: -3.180266, lat: 53.3526958 },
        { lng: -3.1095412, lat: 53.2788586 },
        { lng: -3.0666255, lat: 53.2743421 },
        { lng: -3.0058573, lat: 53.28789 },
        { lng: -3.0037996, lat: 53.2940506 },
        { lng: -2.9735861, lat: 53.298772 },
        { lng: -2.9624265, lat: 53.3020528 },
        { lng: -2.9564185, lat: 53.3051264 },
        { lng: -2.9615421, lat: 53.3385231 },
        { lng: -3.0010928, lat: 53.3751722 },
        { lng: -3.0151265, lat: 53.4099612 },
        { lng: -3.0092697, lat: 53.4119015 },
        { lng: -3.0034126, lat: 53.4128182 },
        { lng: -2.9887434, lat: 53.38784 },
        { lng: -2.9666969, lat: 53.3734986 },
        { lng: -2.9370362, lat: 53.3609877 },
        { lng: -2.9093281, lat: 53.3416941 },
        { lng: -2.8883545, lat: 53.3464963 },
        { lng: -2.8871527, lat: 53.3471624 },
        { lng: -2.8950489, lat: 53.3581772 },
        { lng: -2.8797749, lat: 53.3695988 },
        { lng: -2.8612317, lat: 53.3777405 },
        { lng: -2.8469009, lat: 53.3745656 },
        { lng: -2.8232086, lat: 53.3740026 },
        { lng: -2.7524838, lat: 53.3399885 },
        { lng: -2.7554014, lat: 53.3284044 },
        { lng: -2.7469905, lat: 53.3196899 },
        { lng: -2.7394369, lat: 53.3185621 },
        { lng: -2.7298243, lat: 53.3176391 },
        { lng: -2.7105154, lat: 53.3210748 },
        { lng: -2.6989253, lat: 53.3358886 },
        { lng: -2.6712018, lat: 53.352081 },
        { lng: -2.6392796, lat: 53.3602327 },
        { lng: -2.5959279, lat: 53.3689331 },
        { lng: -2.5753289, lat: 53.3691442 },
        { lng: -2.5445993, lat: 53.3687871 },
        { lng: -2.5073502, lat: 53.3615067 },
        { lng: -2.4276989, lat: 53.3658091 },
        { lng: -2.3741403, lat: 53.3637604 },
        { lng: -2.3157751, lat: 53.3567941 },
        { lng: -2.2932846, lat: 53.3564889 },
        { lng: -2.2670231, lat: 53.3469575 },
        { lng: -2.2656498, lat: 53.3362986 },
        { lng: -2.2629445, lat: 53.3304143 }
      ]
    }),
  },
  {
    name: "Stoke",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.8126543, lat: 52.905749 },
        { lng: -1.9328173, lat: 52.9512799 },
        { lng: -1.9685228, lat: 53.0694362 },
        { lng: -1.974016, lat: 53.1469293 },
        { lng: -2.0701464, lat: 53.2185273 },
        { lng: -2.0509203, lat: 53.2826169 },
        { lng: -2.0773489, lat: 53.3074516 },
        { lng: -2.1264513, lat: 53.2990348 },
        { lng: -2.1720997, lat: 53.2836558 },
        { lng: -2.2203436, lat: 53.2776007 },
        { lng: -2.3029192, lat: 53.2969828 },
        { lng: -2.3513182, lat: 53.31525 },
        { lng: -2.3997362, lat: 53.3138053 },
        { lng: -2.4031695, lat: 53.282617 },
        { lng: -2.4025155, lat: 53.216446 },
        { lng: -2.4989827, lat: 53.2129797 },
        { lng: -2.5521715, lat: 53.1971427 },
        { lng: -2.5365277, lat: 53.1784148 },
        { lng: -2.4687177, lat: 53.1777775 },
        { lng: -2.4841963, lat: 53.1271206 },
        { lng: -2.5562914, lat: 53.085111 },
        { lng: -2.6477392, lat: 53.0661437 },
        { lng: -2.7554186, lat: 52.9777485 },
        { lng: -2.7036628, lat: 52.9444841 },
        { lng: -2.6780822, lat: 52.8904209 },
        { lng: -2.5351334, lat: 52.8576595 },
        { lng: -2.4093492, lat: 52.7547414 },
        { lng: -2.2533198, lat: 52.7369546 },
        { lng: -2.0395906, lat: 52.6534307 },
        { lng: -2.0103272, lat: 52.6477069 },
        { lng: -1.9868974, lat: 52.659687 },
        { lng: -1.9469828, lat: 52.6572921 },
        { lng: -1.9118745, lat: 52.6624896 },
        { lng: -1.8931664, lat: 52.6767854 },
        { lng: -1.9069792, lat: 52.6974635 },
        { lng: -1.9053514, lat: 52.7410252 },
        { lng: -1.8511793, lat: 52.8503549 },
        { lng: -1.8126543, lat: 52.905749 }
      ]
    }),
  },
  {
    name: "Teesside",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.5281206, lat: 54.7953416 },
        { lng: -1.5328699, lat: 54.7850444 },
        { lng: -1.5324684, lat: 54.7797954 },
        { lng: -1.5314672, lat: 54.7718228 },
        { lng: -1.53038, lat: 54.768305 },
        { lng: -1.5293372, lat: 54.7697844 },
        { lng: -1.5284307, lat: 54.7708222 },
        { lng: -1.5222024, lat: 54.7678494 },
        { lng: -1.5143012, lat: 54.7639344 },
        { lng: -1.5073503, lat: 54.7630939 },
        { lng: -1.4902251, lat: 54.759952 },
        { lng: -1.4566278, lat: 54.7457103 },
        { lng: -1.450968, lat: 54.7289407 },
        { lng: -1.4460107, lat: 54.6969875 },
        { lng: -1.4399175, lat: 54.6956357 },
        { lng: -1.4250705, lat: 54.6845615 },
        { lng: -1.4053592, lat: 54.6409664 },
        { lng: -1.3726289, lat: 54.6062762 },
        { lng: -1.3313735, lat: 54.5781354 },
        { lng: -1.3225037, lat: 54.5783934 },
        { lng: -1.3169745, lat: 54.5773534 },
        { lng: -1.3155655, lat: 54.5738259 },
        { lng: -1.3120817, lat: 54.5713477 },
        { lng: -1.3140051, lat: 54.5698644 },
        { lng: -1.3149632, lat: 54.5684064 },
        { lng: -1.3160501, lat: 54.5678689 },
        { lng: -1.3160219, lat: 54.5664359 },
        { lng: -1.313206, lat: 54.5605599 },
        { lng: -1.3210164, lat: 54.5495971 },
        { lng: -1.3356652, lat: 54.5422055 },
        { lng: -1.3619763, lat: 54.5271909 },
        { lng: -1.3812407, lat: 54.5174513 },
        { lng: -1.3986069, lat: 54.5053174 },
        { lng: -1.4080857, lat: 54.5013245 },
        { lng: -1.4120688, lat: 54.4895558 },
        { lng: -1.4234589, lat: 54.4666136 },
        { lng: -1.3772032, lat: 54.4466701 },
        { lng: -1.3302861, lat: 54.4243046 },
        { lng: -1.2902576, lat: 54.4239029 },
        { lng: -1.2588315, lat: 54.4209006 },
        { lng: -1.2429929, lat: 54.4270721 },
        { lng: -1.2175871, lat: 54.430667 },
        { lng: -1.1310708, lat: 54.429384 },
        { lng: -1.0967383, lat: 54.4314658 },
        { lng: -0.9539161, lat: 54.4353597 },
        { lng: -0.8668547, lat: 54.4364082 },
        { lng: -0.8262787, lat: 54.4708589 },
        { lng: -0.7414383, lat: 54.5072181 },
        { lng: -0.7302416, lat: 54.5302988 },
        { lng: -0.7446613, lat: 54.5318925 },
        { lng: -0.7424303, lat: 54.5348805 },
        { lng: -0.7424414, lat: 54.5377755 },
        { lng: -0.8145287, lat: 54.5590756 },
        { lng: -0.8289482, lat: 54.5702225 },
        { lng: -0.8687734, lat: 54.5765908 },
        { lng: -0.896239, lat: 54.5777848 },
        { lng: -0.9333177, lat: 54.5933028 },
        { lng: -0.9717695, lat: 54.5893244 },
        { lng: -1.0521066, lat: 54.61637 },
        { lng: -1.1269505, lat: 54.6358476 },
        { lng: -1.1358768, lat: 54.6473708 },
        { lng: -1.1571627, lat: 54.6378346 },
        { lng: -1.1770753, lat: 54.6636567 },
        { lng: -1.1860016, lat: 54.6831117 },
        { lng: -1.1770753, lat: 54.6985897 },
        { lng: -1.258099, lat: 54.7362676 },
        { lng: -1.2979241, lat: 54.7687616 },
        { lng: -1.3075372, lat: 54.7846028 },
        { lng: -1.3082238, lat: 54.8032083 },
        { lng: -1.3147468, lat: 54.8189371 },
        { lng: -1.3871876, lat: 54.8225964 },
        { lng: -1.4554587, lat: 54.8324432 },
        { lng: -1.4869937, lat: 54.8174344 },
        { lng: -1.5281206, lat: 54.7953416 }
      ]
    }),
  },
  {
    name: "Tockwith",
    polygon: new google.maps.Polygon({
      paths: [
        { lng: -1.4156256, lat: 54.429632 },
        { lng: -1.442578, lat: 54.4107654 },
        { lng: -1.4837924, lat: 54.4048625 },
        { lng: -1.5331203, lat: 54.3870708 },
        { lng: -1.5988197, lat: 54.3302479 },
        { lng: -1.7208928, lat: 54.3110254 },
        { lng: -1.7268957, lat: 54.3027077 },
        { lng: -1.7325512, lat: 54.2831705 },
        { lng: -1.7164542, lat: 54.248228 },
        { lng: -1.737432, lat: 54.2189019 },
        { lng: -1.8828327, lat: 54.1643646 },
        { lng: -1.8648441, lat: 54.1485913 },
        { lng: -1.8353797, lat: 54.1253171 },
        { lng: -1.8279258, lat: 54.1042839 },
        { lng: -1.9109913, lat: 54.0855355 },
        { lng: -1.9919729, lat: 54.0864673 },
        { lng: -2.0554862, lat: 54.0673266 },
        { lng: -1.8233872, lat: 53.9860416 },
        { lng: -1.9504387, lat: 53.9791801 },
        { lng: -1.9361663, lat: 53.9453441 },
        { lng: -1.8507821, lat: 53.9221297 },
        { lng: -1.7862295, lat: 53.9040356 },
        { lng: -1.6983502, lat: 53.8924187 },
        { lng: -1.6111775, lat: 53.8876096 },
        { lng: -1.4930053, lat: 53.8639822 },
        { lng: -1.4522893, lat: 53.851682 },
        { lng: -1.4474223, lat: 53.8479839 },
        { lng: -1.4382542, lat: 53.8466534 },
        { lng: -1.4031052, lat: 53.8493424 },
        { lng: -1.3710932, lat: 53.8537186 },
        { lng: -1.3486954, lat: 53.8546533 },
        { lng: -1.339646, lat: 53.8466617 },
        { lng: -1.3402122, lat: 53.8303647 },
        { lng: -1.3411221, lat: 53.8150779 },
        { lng: -1.3454641, lat: 53.8091144 },
        { lng: -1.4093587, lat: 53.7892476 },
        { lng: -1.3738567, lat: 53.7815552 },
        { lng: -1.3023209, lat: 53.7812392 },
        { lng: -1.2750967, lat: 53.7532314 },
        { lng: -1.2749805, lat: 53.7427196 },
        { lng: -1.2896232, lat: 53.730786 },
        { lng: -1.2740662, lat: 53.693838 },
        { lng: -1.253212, lat: 53.6749759 },
        { lng: -1.2518568, lat: 53.6478333 },
        { lng: -1.2893949, lat: 53.6405578 },
        { lng: -1.3461061, lat: 53.5927408 },
        { lng: -1.3510755, lat: 53.5532707 },
        { lng: -1.3350235, lat: 53.5364943 },
        { lng: -1.3296242, lat: 53.5148198 },
        { lng: -1.2859031, lat: 53.5124933 },
        { lng: -1.2380794, lat: 53.4987159 },
        { lng: -1.2140684, lat: 53.4905703 },
        { lng: -1.1824227, lat: 53.49212 },
        { lng: -1.1531377, lat: 53.4768278 },
        { lng: -1.1299298, lat: 53.4756349 },
        { lng: -1.0786674, lat: 53.4669032 },
        { lng: -0.9752771, lat: 53.4670167 },
        { lng: -0.8873798, lat: 53.6615613 },
        { lng: -0.8729295, lat: 53.6833208 },
        { lng: -0.8651961, lat: 53.6876494 },
        { lng: -0.9330018, lat: 53.6948169 },
        { lng: -0.9697874, lat: 53.7347473 },
        { lng: -0.8180174, lat: 53.8422569 },
        { lng: -0.7931523, lat: 53.8557333 },
        { lng: -0.7318659, lat: 53.8774925 },
        { lng: -0.7211915, lat: 53.8888227 },
        { lng: -0.7081548, lat: 53.9316788 },
        { lng: -0.7005897, lat: 53.976151 },
        { lng: -0.7967369, lat: 54.0574548 },
        { lng: -0.9124276, lat: 54.127531 },
        { lng: -0.945062, lat: 54.1313528 },
        { lng: -1.0174657, lat: 54.1627289 },
        { lng: -1.0580272, lat: 54.2061243 },
        { lng: -1.1802506, lat: 54.2763531 },
        { lng: -1.2513381, lat: 54.3568677 },
        { lng: -1.2554532, lat: 54.4184398 },
        { lng: -1.3138255, lat: 54.4218419 },
        { lng: -1.3730499, lat: 54.4187482 },
        { lng: -1.4156256, lat: 54.429632 }
      ]
    }),
  },
];

function inAreaForm() {
  let address = document.getElementById("addressSearch");
  let addressPC = document.getElementById("postalCode");
  let validAddress = false;
  let validPostcode = false;

  // Validate address
    if (address) {
      let addressValue = address.value;
      if (addressValue == "") {
        address.className += " invalid";
        address.placeholder = "Please type your address";
        validAddress = false;
      }  else {
        address.className -= " invalid";
        validAddress = true;
      }
    }

    // Validate postcode
    if (addressPC) {
      let addressPcValue = address.value;
      if (addressPcValue == "") {
        addressPC.className += " invalid";
        addressPC.placeholder = "Please add your postcode";
        validPostcode = false;
      }  else {
        addressPC.className -= " invalid";
        validPostcode = true;
      }
    }

  if(validAddress == true && validPostcode == true){
    document.querySelector('#firstStep').style.display = 'none';
    document.querySelector('#secondStep').style.display = 'block';
  
    document.querySelector('#full_address').value = userData.address;
    document.querySelector('#postcode').value = userData.postcode;
  }
}

function notInAreaForm() {
  let address = document.getElementById("addressSearch");
  let addressPC = document.getElementById("postalCode");
  let validAddress = false;
  let validPostcode = false;

  // Validate address
    if (address) {
      console.log("ADDRESS");
      let addressValue = address.value;
      if (addressValue == "") {
        address.className += " invalid";
        address.placeholder = "Please type your address or postcode";
        validAddress = false;
        console.log("INVALID ADD");
      }  else {
        address.className -= " invalid";
        validAddress = true;
        console.log("VALID ADD");
      }
    }

    // Validate postcode
    if (addressPC) {
      console.log("ADDRESS Pc");
      let addressPcValue = address.value;
      if (addressPcValue == "") {
        //addressPC.className += " invalid";
        addressPC.placeholder = "Please type your address or postcode";
        validPostcode = false;
        console.log("INVALID PC");
      }  else {
        addressPC.className -= " invalid";
        validPostcode = true;
        console.log("VALID PC");
      }
    }

  if(validAddress == true && validPostcode == true){
    document.querySelector('#firstStep').style.display = 'none';
    document.querySelector('#notFoundStep').style.display = 'block';
  }
}

// use the geocoder to get the LatLng of the postcode
let geocoder = new google.maps.Geocoder();

// Take a written address, geocode it, and look it up in all the polygons.
document.getElementById('checkBtn').addEventListener('click', function() {
  let lat = document.getElementById("PCCLat").value;
  let lng = document.getElementById("PCCLng").value;
  lookup(lat,lng);
});

document.getElementById('found_back_btn').addEventListener('click', function() {
  document.querySelector('#firstStep').style.display = 'block';
  document.querySelector('#secondStep').style.display = 'none';
});
document.getElementById('not_found_back_btn').addEventListener('click', function() {
  document.querySelector('#firstStep').style.display = 'block';
  document.querySelector('#notFoundStep').style.display = 'none';
});


document.getElementById('arrange_visit').addEventListener('click', function() {
  let regexEm = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  let regexName = /\b([A-ZÀ-ÿ][-,a-z. ']+[ ]*)+/gim;
  let regexLastName = /\b([A-ZÀ-ÿ][-,a-z. ']+[ ]*)+/gim;
  let regexPhone = /^[\d ()+-]{11,}$/;

  let email = document.getElementById("PCCEmail");
  let fullName = document.getElementById("PCCName");
  let lastname = document.getElementById("PCCLastName");
  let phone = document.getElementById("PCCNumber");

  let validValuesArr = [];
  let validName = false;
  let validLastName = false;
  let validEmail = false;
  let validPhone = false;

  if(regexEm.test(email.value) == true){
    userData.email = email.value;
    validEmail = true;
    console.log('VALID EMAIL');
  }else {
    email.className += " invalid";
    email.placeholder = "Please check your email";
    validEmail = false;
    console.log('INVALID EMAIL');
  }

  if(regexName.test(fullName.value) == true){
    userData.name = fullName.value;
    validName = true;
    console.log('VALID NAME');
  }else {
    fullName.className += " invalid";
    fullName.placeholder = "Please check your name";
    validName = false;
    console.log('INVALID NAME');
  }

  if(regexLastName.test(lastname.value) == true){
    userData.lastname = lastname.value;
    validLastName = true;
    console.log('VALID LASTNAME');
  }else {
    lastname.className += " invalid";
    lastname.placeholder = "Please check your last name";
    validLastName = false;
    console.log('INVALID LASTNAME');
  }

  if(regexPhone.test(phone.value) == true){
    userData.phone = phone.value;
    validPhone = true;
    console.log('VALID PHONE');
  }else {
    phone.className += " invalid";
    phone.placeholder = "Please check your phone";
    validPhone = false;
    console.log('INVALID PHONE');
  }

  if (validEmail === true && validName === true && validLastName === true && validPhone === true) {
    userData.optin = document.getElementById("PCCOptIn").checked; 
    
    document.querySelector('#firstStep').style.display = 'none';
    document.querySelector('#secondStep').style.display = 'none';
    document.querySelector('#thirdStep').style.display = 'block';
    console.log(userData);
    //submit to klaviyo function
    sendUserData(userData, "New_Leads")
    submitToKlaviyo();
  }
});

document.getElementById('submitNotFoundEmail').addEventListener('click', function() {
  let regexEm = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  let email = document.getElementById("PCCNotFoundEmail");
  let validEmail = false;

  if(regexEm.test(email.value) == true){
    userData.email = email.value;
    validEmail = true;
    console.log('VALID EMAIL');
  }else {
    email.className += " invalid";
    email.placeholder = "Please check your email";
    validEmail = false;
    console.log('INVALID EMAIL');
  }

  if (validEmail == true) {
    userData.optin = document.getElementById("PCCNotFoundOptIn").checked;

    document.querySelector('#notFoundStep').style.display = 'none';
    document.querySelector('#notFoundSecondStep').style.display = 'block';
    console.log(userData);
    //submit to klaviyo function
    submitToKlaviyo();
  }
});

const lookup = async (lat, lng) => {
  // Iterate through the polygons and see if the lat long is in any of them
  for (const poly of polygons) {
    const found = google.maps.geometry.poly.containsLocation(
      new google.maps.LatLng(lat, lng),
      poly.polygon
    );
    if (found) {
      console.log(`Found in ${poly.name} region`);
      klaviyoFlags.inArea = "Yes";
      inAreaForm();
      return true;
    }
  }

  console.log("Not found in any region");
  notInAreaForm();
  return false;
};

// getaddress.io event listeners
document.addEventListener("getaddress-autocomplete-address-selected", function (e) {
  console.log(e.address);
  let address = e.address;
  let displayedAddress = address.postcode;

  document.getElementById("PCCLat").value = address.latitude;
  document.getElementById("PCCLng").value = address.longitude;

  document.getElementById("auto-built-address").value = displayedAddress;

  userData.postcode = address.postcode;
  userData.address = address.formatted_address[0]+' '+address.formatted_address[3]+' '+address.formatted_address[4];

  console.log(userData);
});


// end of getaddress.io event listeners

//sends data to the spreadsheet, the client requested to only save to the spreadshee if is in the area
function sendUserData(data, tabId) {
  //skipping spreadsheet if tab is Raw Data
  if(tabId == "Raw_data") return;
    
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  
  var date = Date();
  
// EXPLICIT MAPPING:
var sheetPayload = [
  date,
  data.email,
  data.name,
  data.lastname,
  data.postcode,
  data.optin ? "Yes" : "No",
  data.phone,
  data.address
];

  var requestOptions = {
    method: "post",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify([sheetPayload]),
  };

  fetch(
    "https://v1.nocodeapi.com/webshopsleaf/google_sheets/dzBwgiDHvyLDJIJi?tabId=" + tabId,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
          let err = new Error("HTTP status code: " + response.status);
          err.response = response;
          err.status = response.status;
          console.log(err);
          console.log("Userdata Response error");
          throw err
        } else {
          console.log("Submited");
        }
    }).catch((error) => {
      console.log("error", error);
    });
}

function setAddressData (address_data) {
  let address = address_data;
  let county = address.Province;
  let town = address.City;
  let displayedAddress = address.PostalCode;
  let fullAddress = "";

  document.getElementById("PCCLat").value = address.Field1;
  document.getElementById("PCCLng").value = address.Field2;

  if (address.Line1 != "") {
    fullAddress += address.Line1;
    document.getElementById("full_address").value = address.Line1;
  } else {
    document.getElementById("full_address").value = '';
  }
  
  document.getElementById("postalCode").value = displayedAddress;
  document.getElementById("postcode").value = address.PostalCode;

  foundPostcode = address.PostalCode;
  userData.postcode = address.PostalCode;
  userData.address = fullAddress;

  console.log(userData);
}

//sends data to klaviyo
async function submitToKlaviyo() {  
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      revision: "2023-11-13",
      "content-type": "application/json",
    },
    body: JSON.stringify({
      data: {
        type: "profile",
        attributes: {
          email: userData.email,
          first_name: userData.name,
          last_name: userData.lastname,
          location: {
            address1: userData.address,
            country: "United Kingdom",
            zip: userData.postcode,
          },
          properties: {
            a_optin: userData.optin,
            b_inArea: klaviyoFlags.inArea,
            l_origin: "Event Entry",
            m_phoneNumber: formatPhoneNumber(userData.phone),
          },
        },
      },
    }),
  };

    const response = await fetch(
      "https://a.klaviyo.com/client/profiles/?company_id=RLGUVp", options).then(response => {
        if (!response.ok) {
          let err = new Error("HTTP status code: " + response.status);
          err.response = response;
          err.status = response.status;
          throw err;
        }else {
          //checks if the subscribe to emails checkbox is checked, if checked executes subscribeToKalviyo
          //else it automatically refresh the page
          optInResponse = userData.optin;
          if (optInResponse) {
            subscribeToKlaviyo();
          }else{
            setTimeout(function() {
              location.reload();
            }, 15000);
          }
        }
      }).catch((error) => {
        console.log("error", error);
      });
}

//if the subscribe to emails checkbox is checked then it will subscribe the user to klaviyo emails
async function subscribeToKlaviyo() {
  optInResponse = document.getElementById("PCCOptIn").checked;
    if (optInResponse) {
      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2023-12-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Event form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: userData.email,
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: 'R3rpvi'}}}
          }
        }),
      };
    
      try {
        const response = await fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=RLGUVp",options);
    
          setTimeout(function() {
            location.reload();
          }, 15000);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
}

function formatPhoneNumber(inputString) {
  // Remove spaces
  let formattedString = inputString.replace(/\s/g, '');

  // Remove leading zero if present
  formattedString = formattedString.replace(/^0+/, '');

  // Add '+44' if not already starting with '+'
  if (!formattedString.startsWith('+')) {
    formattedString = '+44' + formattedString;
  }
  console.log("formatted phone "+formattedString);
  return formattedString;
}

